// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6b3d511186bfa499b3ba","655":"198531e641b35d074213"}[chunkId] + ".js";
};